import { Typography } from "antd";
import type { PaletteHit } from "../helpers/useGlobalSearch";
import { hitSubtitle, hitTitle } from "../helpers/searchTargets";

/**
 * One result row, shared by the palette and the results page so a hit reads the same in
 * both. A record is never shown by its name alone — the code leads, monospaced, and the
 * name sits beside it, which is how every other register in the app identifies a record.
 */

/** Marks the matched run so it is obvious why a row is in the list. */
function Highlight({ text, term }: { text: string; term: string }) {
  const needle = term.trim().toLowerCase();
  const at = needle ? text.toLowerCase().indexOf(needle) : -1;
  if (at < 0) return <>{text}</>;
  return (
    <>
      {text.slice(0, at)}
      <Typography.Text mark>{text.slice(at, at + needle.length)}</Typography.Text>
      {text.slice(at + needle.length)}
    </>
  );
}

export function SearchHit({ hit, term }: { hit: PaletteHit; term: string }) {
  const title = hit.source === "local" ? hit.title : hitTitle(hit.hit);
  const subtitle = hit.source === "local" ? hit.subtitle : hitSubtitle(hit.hit);
  const isCode = hit.source === "server" && !!hit.hit.code;

  return (
    <>
      <span className={isCode ? "glut-search-code" : undefined}>
        <Highlight text={title} term={term} />
      </span>
      {subtitle && (
        <Typography.Text type="secondary" className="glut-search-sub">
          <Highlight text={subtitle} term={term} />
        </Typography.Text>
      )}
    </>
  );
}
